import * as THREE from "three";
import AHMeshEditMaterial from "../AHMeshEditMaterial";

export var MRI_GENERIC_MATERIAL = new THREE.MeshBasicMaterial({
    color: "#ffffff",
    transparent: true,
    opacity: 1.0,
    side: THREE.FrontSide,
});

export const MRI_EDIT_MATERIAL = new AHMeshEditMaterial({
    opacity: 1.0,
    side: THREE.FrontSide,
});
